import {
  BlogIcon,
  Help,
  HomeIcon,
  MilitaryTech,
  SearchIcon,
  ShoppingCartIcon,
  TrophyCupIconFilled,
} from '@/components/icons'
import { ROUTE_DASHBOARD, ROUTE_EVENTS, ROUTE_LOGIN, ROUTE_PLAYERS, ROUTE_SIGNUP } from '@/constants/Routes'
import { Menu } from '@/types'

export const menus: Menu[] = [
  { title: 'Dashboard', href: ROUTE_DASHBOARD, public: false },
  { title: 'SearchPlayer', href: ROUTE_PLAYERS, public: true },
  { title: 'SearchEvents', href: ROUTE_EVENTS, public: true },
  { title: 'Rankings', href: 'https://www.blog.mydupr.com/rankings', public: true },
  { title: 'Genie', href: 'https://genie.mydupr.com/', public: true },
  { title: 'Shops', href: 'https://www.blog.mydupr.com/shop', public: true },
  { title: 'HowItWorks', href: 'https://www.support.mydupr.com/', public: true },
  { title: 'RunEvents', href: '', public: true },
  { title: 'CollegiatePickleball', href: 'https://www.blog.mydupr.com/collegiate', public: true },
  { title: 'FlexLeague', href: 'https://www.blog.mydupr.com/post/dupr-flex-leagues', public: true },
  { title: 'News', href: 'https://www.blog.mydupr.com/', public: true },
  { title: 'LogIn', href: ROUTE_LOGIN, public: false },
  { title: 'SignUp', href: ROUTE_SIGNUP, public: false },
]

export const drawerMenus: Menu[] = [
  {
    title: 'Dashboard',
    href: ROUTE_DASHBOARD,
    icon: <HomeIcon className="w-6 h-6 text-darkBlue" />,
    public: false,
  },
  {
    title: 'SearchPlayer',
    href: ROUTE_PLAYERS,
    icon: <SearchIcon className="w-6 h-6 text-darkBlue" />,
    public: true,
  },
  {
    title: 'SearchEvents',
    href: ROUTE_EVENTS,
    icon: <TrophyCupIconFilled className="w-6 h-6 text-darkBlue" />,
    public: true,
  },
  {
    title: 'News',
    href: 'https://www.blog.mydupr.com/',
    icon: <BlogIcon className="w-6 h-6 text-darkBlue" />,
    public: true,
  },
  {
    title: 'Rankings',
    href: 'https://www.blog.mydupr.com/rankings',
    icon: <MilitaryTech className="w-6 h-6 text-darkBlue" />,
    public: true,
  },
  {
    title: 'Genie',
    href: 'https://genie.mydupr.com/',
    icon: <TrophyCupIconFilled className="w-6 h-6 text-darkBlue" />,
    public: true,
  },
  {
    title: 'Shops',
    href: 'https://www.blog.mydupr.com/shop',
    icon: <ShoppingCartIcon className="w-6 h-6 text-darkBlue" />,
    public: true,
  },
  {
    title: 'HowItWorks',
    href: 'https://www.support.mydupr.com/',
    icon: <Help className="w-6 h-6 text-darkBlue" />,
    public: true,
  },
  {
    title: 'RunEvents',
    href: '',
    icon: <TrophyCupIconFilled className="w-6 h-6 text-darkBlue" />,
    public: true,
  },
  {
    title: 'CollegiatePickleball',
    href: 'https://www.blog.mydupr.com/collegiate',
    icon: <TrophyCupIconFilled className="w-6 h-6 text-darkBlue" />,
    public: true,
  },
  {
    title: 'FlexLeague',
    href: 'https://www.blog.mydupr.com/post/dupr-flex-leagues',
    icon: <TrophyCupIconFilled className="w-6 h-6 text-darkBlue" />,
    public: true,
  },
]

export const tabletMenus: Menu[] = [
  { title: 'Dashboard', href: ROUTE_DASHBOARD, public: false },
  { title: 'HowItWorks', href: 'https://www.support.mydupr.com/', public: true },
  { title: 'RunEvents', href: '', public: true },
  { title: 'CollegiatePickleball', href: 'https://www.blog.mydupr.com/collegiate', public: true },
  { title: 'FlexLeague', href: 'https://www.blog.mydupr.com/post/dupr-flex-leagues', public: true },
  { title: 'News', href: 'https://www.blog.mydupr.com/', public: true },
  { title: 'LogIn', href: ROUTE_LOGIN, public: false },
  { title: 'SignUp', href: ROUTE_SIGNUP, public: false },
]
